import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlay,
  faPause,
  faForward,
  faRandom,
} from '@fortawesome/free-solid-svg-icons';
import { useMusicPlayer } from '../music/music_player_context';

export default function VaultHeader({ noteCount }) {
  const countLabel = `${noteCount} ${noteCount === 1 ? 'note' : 'notes'}`;
  const {
    playTrack,
    isPlaying,
    shuffleMode,
    togglePlay,
    handleNextTrack,
    handleShuffle,
  } = useMusicPlayer();

  const art = playTrack?.thumbnail_medium || playTrack?.thumbnail_default || '';
  const title = playTrack?.title || playTrack?.name || '';
  const artist = playTrack?.artist || '';

  return (
    <header className="vault-header">
      <div className="vault-header-brand">
        <span className="vault-header-mark">Vault</span>
        <span className="vault-header-count">{countLabel}</span>
      </div>

      {playTrack && (
        <div className="vault-now-playing" aria-label="Now playing">
          <div className="vault-now-playing-meta">
            <div className="vault-now-playing-art" aria-hidden="true">
              {art ? <img src={art} alt="" /> : <span className="vault-now-playing-art-fallback" />}
            </div>
            <div className="vault-now-playing-text">
              <div className="vault-now-playing-title">{title}</div>
              {artist && <div className="vault-now-playing-artist">{artist}</div>}
            </div>
          </div>
          <div className="vault-now-playing-controls">
            <button
              type="button"
              className="vault-now-playing-btn vault-now-playing-btn--primary"
              onClick={togglePlay}
              aria-label={isPlaying ? 'Pause' : 'Play'}
            >
              <FontAwesomeIcon icon={isPlaying ? faPause : faPlay} />
            </button>
            <button
              type="button"
              className="vault-now-playing-btn"
              onClick={handleNextTrack}
              aria-label="Next"
            >
              <FontAwesomeIcon icon={faForward} />
            </button>
            <button
              type="button"
              className={`vault-now-playing-btn${shuffleMode ? ' is-active' : ''}`}
              onClick={handleShuffle}
              aria-label="Shuffle"
              aria-pressed={shuffleMode}
              title={shuffleMode ? 'Shuffle on' : 'Shuffle off'}
            >
              <FontAwesomeIcon icon={faRandom} />
            </button>
          </div>
        </div>
      )}

    </header>
  );
}
